'use client';

import {
  SortSheet,
  type SortDir,
  type SortFieldOption,
} from '@paeffgen/react/crm-documents/ui';

/** Sortierbare Felder eines Favoriten (quantity/amount sind serverseitig stets 0 → ausgelassen). */
export type FavoritesSortField =
  | 'addedAt'
  | 'description'
  | 'articleNumber'
  | 'unitPrice';

export interface FavoritesSort {
  field: FavoritesSortField;
  direction: SortDir;
}

/** Default: Beschreibung A→Z (entspricht dem bisherigen „name-asc"). */
export const FAVORITES_SORT_DEFAULT: FavoritesSort = {
  field: 'description',
  direction: 'asc',
};

export const FAVORITES_SORT_OPTIONS: SortFieldOption<FavoritesSortField>[] = [
  { id: 'addedAt', label: 'Zuletzt hinzugefügt', descSub: 'Neueste zuerst', ascSub: 'Älteste zuerst' },
  { id: 'description', label: 'Beschreibung', descSub: 'Z → A', ascSub: 'A → Z' },
  { id: 'articleNumber', label: 'Artikelnummer', descSub: 'Z → A', ascSub: 'A → Z' },
  { id: 'unitPrice', label: 'Letzter Preis', descSub: 'Höchster zuerst', ascSub: 'Niedrigster zuerst' },
];

interface FavoritesSortSheetProps {
  open: boolean;
  onClose: () => void;
  value: FavoritesSort;
  onChange: (value: FavoritesSort) => void;
}

export function FavoritesSortSheet({
  open,
  onClose,
  value,
  onChange,
}: FavoritesSortSheetProps) {
  return (
    <SortSheet<FavoritesSortField>
      open={open}
      onClose={onClose}
      options={FAVORITES_SORT_OPTIONS}
      sortKey={value.field}
      sortDir={value.direction}
      onChangeSortKey={(field) => onChange({ ...value, field })}
      onChangeSortDir={(direction) => onChange({ ...value, direction })}
    />
  );
}
